<div class="inline-flex text-sm font-bold uppercase">
  {{ strategy() | boxSaleMissingItemPickStrategy | async }}
</div>
